module.exports = __webpack_public_path__ + "static/media/logo.112d4b93.svg";